//外送(1)／外帶(2)／UB(4) 單的飲品預設「外帶杯」：商品規格裡有名稱以「外帶杯」結尾的細項（如「容器」類別），
//且該類別還沒選，就幫忙先選上；店員／客人仍可改選內用杯或取消
export const TAKEOUT_METHODS = [1, 2, 4];
const TAKEOUT_CUP_PATTERN = /外帶杯$/;

export const isTakeoutMethod = (method) => TAKEOUT_METHODS.includes(Number(method));

export const findTakeoutCup = (systemData, meal) => {
    const categoryIds = new Set((meal?.composition ?? []).map((composition) => String(composition.category_id)));
    return (systemData?.food ?? []).find((food) =>
        categoryIds.has(String(food.category_id)) &&
        TAKEOUT_CUP_PATTERN.test(String(food.name ?? "").trim()) &&
        Number(food.status ?? 1) < 2 &&
        Number(food.price ?? 0) >= 0
    );
};

export const withTakeoutCup = (systemData, meal, detail, method, makeItem = (food) => ({ food_id: food.pd_id, qty: 1 })) => {
    const current = detail ?? [];
    if (!isTakeoutMethod(method)) return current;
    const cup = findTakeoutCup(systemData, meal);
    if (!cup) return current;
    const pickedInGroup = current.some((item) => {
        const food = (systemData?.food ?? []).find((option) => String(option.pd_id) === String(item.food_id));
        return String(food?.category_id) === String(cup.category_id);
    });
    return pickedInGroup ? current : [...current, makeItem(cup)];
};
